<template>
  <aside class="app-sidebar" :class="{ 'app-sidebar--collapsed': collapsed }">
    <div class="app-sidebar__header">
      <button
        type="button"
        class="app-sidebar__toggle"
        :title="collapsed ? 'Развернуть меню' : 'Свернуть меню'"
        :aria-label="collapsed ? 'Развернуть меню' : 'Свернуть меню'"
        @click="toggleCollapsed"
      >
        <i :class="collapsed ? 'fas fa-chevron-right' : 'fas fa-chevron-left'" aria-hidden="true"></i>
      </button>
    </div>
    <nav class="app-sidebar__nav" aria-label="Основное меню">
      <router-link
        v-for="item in menuItems"
        :key="item.id"
        :to="item.route"
        class="app-sidebar__link"
        :class="{ 'app-sidebar__link--active': isActive(item) }"
        :title="item.title"
      >
        <i :class="['app-sidebar__icon', item.icon]" aria-hidden="true"></i>
        <span v-if="!collapsed" class="app-sidebar__label">{{ item.label }}</span>
      </router-link>
    </nav>
  </aside>
</template>

<script>
import { sidebarMenuItems } from '../config/sidebarMenu';
import { useUserStore } from '../stores/userStore';

const SIDEBAR_COLLAPSED_KEY = 'tcp-sidebar-collapsed';

export default {
  name: 'AppSidebar',
  data() {
    return {
      collapsed: false,
    };
  },
  computed: {
    menuItems() {
      const userStore = useUserStore();
      return sidebarMenuItems.filter((item) => {
        if (item.adminOnly) return userStore.isAdmin;
        if (item.id === 'history') return userStore.hasPermission('calc.history.view');
        if (item.id === 'report') return userStore.hasPermission('calc.report.export');
        return true;
      });
    },
  },
  mounted() {
    try {
      this.collapsed = localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === '1';
    } catch {
      this.collapsed = false;
    }
  },
  methods: {
    toggleCollapsed() {
      this.collapsed = !this.collapsed;
      try {
        localStorage.setItem(SIDEBAR_COLLAPSED_KEY, this.collapsed ? '1' : '0');
      } catch {
        /* ignore */
      }
    },
    isActive(item) {
      const path = this.$route.path;
      if (item.id === 'calculate') {
        return path.startsWith('/app/calculate');
      }
      return path === item.route || path.startsWith(`${item.route}/`);
    },
  },
};
</script>

<style scoped>
.app-sidebar {
  width: 240px;
  min-height: 100%;
  background: var(--tcp-gradient-sidebar);
  border-right: 1px solid var(--tcp-color-border);
  display: flex;
  flex-direction: column;
  transition: width 0.25s ease;
  flex-shrink: 0;
}

.app-sidebar--collapsed {
  width: 56px;
}

.app-sidebar__header {
  padding: 0.5rem;
  display: flex;
  justify-content: flex-end;
  border-bottom: 1px solid var(--tcp-color-border);
}

.app-sidebar__toggle {
  width: 32px;
  height: 32px;
  border: none;
  background: var(--tcp-color-brand-muted-strong);
  color: var(--tcp-color-brand-start);
  border-radius: var(--tcp-radius-sm);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, color 0.2s;
}

.app-sidebar__toggle:hover {
  background: var(--tcp-color-brand-muted-hover);
  color: var(--tcp-color-brand-hover);
}

.app-sidebar__nav {
  padding: 0.75rem 0;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.app-sidebar__link {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.65rem 1rem;
  color: var(--tcp-color-nav);
  text-decoration: none;
  transition: background 0.2s, color 0.2s;
  white-space: nowrap;
  border-left: 3px solid transparent;
  margin: 0 0.25rem;
  border-radius: 0 var(--tcp-radius-sm) var(--tcp-radius-sm) 0;
}

.app-sidebar--collapsed .app-sidebar__link {
  padding: 0.65rem;
  justify-content: center;
}

.app-sidebar__link:hover {
  background: var(--tcp-color-brand-muted);
  color: var(--tcp-color-brand-start);
}

.app-sidebar__link--active {
  background: var(--tcp-color-brand-muted-strong);
  color: var(--tcp-color-brand-start);
  border-left-color: var(--tcp-color-brand-start);
  font-weight: 600;
}

.app-sidebar__icon {
  width: 1.25rem;
  text-align: center;
  flex-shrink: 0;
  font-size: 1.1rem;
}

.app-sidebar__label {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
